import { IconButton } from "@mui/material"
import { VisibilityOutlined } from "@mui-symbols-material/w300"
import type { ColumnDef } from "@tanstack/react-table"
import type { FC } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { EquivalencyGroup } from "@/graphql/codegen/graphql"
import { EquivalencyTypeChip } from "@/screens/ManageProducts/components/EquivalentProductGroups/components/EquivalencyTypeChip"

interface ProductEquivalentGroupsTableProps {
  groups: EquivalencyGroup[]
  onViewGroup: (group: EquivalencyGroup) => void
}

export const ProductEquivalentGroupsTable: FC<ProductEquivalentGroupsTableProps> = ({ groups, onViewGroup }) => {
  const columns: ColumnDef<EquivalencyGroup>[] = [
    {
      accessorKey: "name",
      header: "",
      cell: ({ row }) => <span className='text-sm text-gray-900'>{row.original.name}</span>,
      enableSorting: false,
      size: 250,
    },
    {
      accessorKey: "type",
      header: "",
      cell: ({ row }) => <EquivalencyTypeChip type={row.original.type} />,
      size: 120,
      enableSorting: false,
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }) => (
        <IconButton
          size='small'
          onClick={() => onViewGroup(row.original)}
          aria-label={`View ${row.original.name} group details`}
          data-testid='view-group-button'
          className='ml-auto'
        >
          <VisibilityOutlined />
        </IconButton>
      ),
      size: 80,
      enableSorting: false,
    },
  ]

  return (
    <AerosBaseTable
      features={{
        tanstackOptions: {
          data: groups,
          columns,
        },
      }}
      slotProps={{
        container: {
          className: "[&_thead]:hidden [&_table]:border-t [&_table]:border-gray-200 max-h-[280px] overflow-y-auto",
        },
      }}
      noDataMessage='No equivalent groups found'
      data-testid='product-equivalent-groups-table'
    />
  )
}
